import React from "react";
import colors from "@streeteasy/design-system/deprecated/colors";
import Dismissable from "@streeteasy/design-system/legacy/Dismissable";
import TimedDismissable from "@streeteasy/design-system/legacy/TimedDismissable";
import {
  bool,
  func,
  instanceOf,
  node,
  number,
  oneOf,
  string
} from "prop-types";

import * as S from "./styled";

export class Toast extends React.Component {
  componentDidMount() {
    this.props.onShow();
  }

  render() {
    const {
      closeButtonColor,
      icon,
      isAutoWidth,
      message,
      offsetY,
      onHide,
      onShow,
      optionalStyles,
      theme,
      time,
      ...passThroughProps
    } = this.props;
    const ToastContainer = time > 0 ? TimedDismissable : Dismissable;
    return (
      <S.Toast
        isAutoWidth={isAutoWidth}
        offsetY={`${offsetY}px`}
        role="alert"
        {...passThroughProps}
      >
        <ToastContainer
          closeButtonColor={closeButtonColor}
          onToggle={onHide}
          time={time}
        >
          <S.Container optionalStyles={optionalStyles} theme={theme}>
            <S.Icon icon={icon} theme={theme} />
            <S.ToastText type="sm">{message}</S.ToastText>
          </S.Container>
        </ToastContainer>
      </S.Toast>
    );
  }
}

Toast.propTypes = {
  /**
   * Optional custom color for the close button, defaults to goatGrey from
   * the StreetEasy color palette.
   */
  closeButtonColor: string,
  /**
   * A single word in an enum which indicates the font-awesome class
   * of icon which appears in the ToastIcon styled component.
   * Default value is "check". See propTypes below for
   * eligible values.
   */
  icon: oneOf(["check", "key", "star", "times", "heart", "warning"]),
  /**
   * Message which appears in Toast container
   */
  message: node.isRequired,
  /** Sets width to auto providing a true value for this option, by default it is 100% */
  isAutoWidth: bool,
  /** This will set a top value on the toast since it has position: fixed. */
  offsetY: number,
  /**
   * Function called when Toast times out, or is closed
   * by clicking on the "X" icon. Default value is
   * an empty function
   */
  onHide: func,
  /**
   * Function called when Toast appears. Common usage of this function is
   * for adding GA tracking. Default value is an empty function.
   */
  onShow: func,
  /**
   * An object of css styles which is passed to the ToastContainer
   * styled component. This is necessary because ToastContainer is
   * position: fixed, and thus cannot be constrained by a wrapping
   * container.
   */
  optionalStyles: instanceOf(Object),
  /** Changes background and border colors. Default value is white. */
  theme: oneOf(["default", "blue", "red"]),
  /**
   * If this prop will receive the number that more then 0 the Toast will
   * return a TimedDismissable component that will linger for some time
   * which is equal the prop's value in ms.
   */
  time: number
};

Toast.defaultProps = {
  closeButtonColor: colors.goatGrey,
  icon: "check",
  isAutoWidth: false,
  offsetY: 65,
  onHide: () => {},
  onShow: () => {},
  optionalStyles: {},
  theme: "default",
  time: 0
};

export default Toast;
